/* eslint-disable */
/******/ (function (modules) {
  // webpackBootstrap

  /******/ // The module cache

  /******/ var installedModules = {};

  /******/

  /******/ // The require function

  /******/ function __webpack_require__(moduleId) {
    /******/

    /******/ // Check if module is in cache

    /******/ if (installedModules[moduleId]) {
      /******/ return installedModules[moduleId].exports;

      /******/
    }

    /******/ // Create a new module (and put it into the cache)

    /******/ var module = (installedModules[moduleId] = {
      /******/ i: moduleId,

      /******/ l: false,

      /******/ exports: {},

      /******/
    });

    /******/

    /******/ // Execute the module function

    /******/ modules[moduleId].call(
      module.exports,
      module,
      module.exports,
      __webpack_require__,
    );

    /******/

    /******/ // Flag the module as loaded

    /******/ module.l = true;

    /******/

    /******/ // Return the exports of the module

    /******/ return module.exports;

    /******/
  }

  /******/

  /******/

  /******/ // expose the modules object (__webpack_modules__)

  /******/ __webpack_require__.m = modules;

  /******/

  /******/ // expose the module cache

  /******/ __webpack_require__.c = installedModules;

  /******/

  /******/ // define getter function for harmony exports

  /******/ __webpack_require__.d = function (exports, name, getter) {
    /******/ if (!__webpack_require__.o(exports, name)) {
      /******/ Object.defineProperty(exports, name, {
        /******/ configurable: false,

        /******/ enumerable: true,

        /******/ get: getter,

        /******/
      });

      /******/
    }

    /******/
  };

  /******/

  /******/ // getDefaultExport function for compatibility with non-harmony modules

  /******/ __webpack_require__.n = function (module) {
    /******/ var getter =
      module && module.__esModule
        ? /******/ function getDefault() {
            return module['default'];
          }
        : /******/ function getModuleExports() {
            return module;
          };

    /******/ __webpack_require__.d(getter, 'a', getter);

    /******/ return getter;

    /******/
  };

  /******/

  /******/ // Object.prototype.hasOwnProperty.call

  /******/ __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };

  /******/

  /******/ // __webpack_public_path__

  /******/ __webpack_require__.p = '../';

  /******/

  /******/ // Load entry module and return exports

  /******/ return __webpack_require__((__webpack_require__.s = 1));

  /******/
})(
  /************************************************************************/

  /******/ [
    /* 0 */

    /***/ function (module, exports) {
      module.exports = jQuery;

      /***/
    },

    /* 1 */

    /***/ function (module, exports, __webpack_require__) {
      __webpack_require__(2);

      module.exports = __webpack_require__(12);

      /***/
    },

    /* 2 */

    /***/ function (module, __webpack_exports__, __webpack_require__) {
      'use strict';

      Object.defineProperty(__webpack_exports__, '__esModule', { value: true });

      /* WEBPACK VAR INJECTION */ (function (jQuery) {
        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Router__ =
          __webpack_require__(6);

        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes_common__ =
          __webpack_require__(8);

        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes_home__ =
          __webpack_require__(9);

        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes_singleVerksamheter__ =
          __webpack_require__(10);

        /* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routes_algoliaMainSearch__ =
          __webpack_require__(11);

        // import external dependencies

        //look here https://roots.io/docs/sage/9.x/compiling-assets/#_3rd-party-packages

        //import local dependencies

        /** Populate Router instance with DOM routes */

        var routes = new __WEBPACK_IMPORTED_MODULE_4__util_Router__[
          'a' /* default */
        ]({
          // All pages

          common:
            __WEBPACK_IMPORTED_MODULE_5__routes_common__['a' /* default */],

          home: __WEBPACK_IMPORTED_MODULE_6__routes_home__['a' /* default */],

          // Home page

          singleVerksamheter:
            __WEBPACK_IMPORTED_MODULE_7__routes_singleVerksamheter__[
              'a' /* default */
            ],

          algoliaMainSearch:
            __WEBPACK_IMPORTED_MODULE_8__routes_algoliaMainSearch__[
              'a' /* default */
            ],
        });

        // Load Events

        jQuery(document).ready(function () {
          return routes.loadEvents();
        });

        /* WEBPACK VAR INJECTION */
      }).call(__webpack_exports__, __webpack_require__(0));

      /***/
    },

    /* 3 */

    /***/ function (module, exports, __webpack_require__) {
      //remved with gallery
      /***/
    },

    /* 4 */

    /***/ function (module, exports, __webpack_require__) {
      //remved with gallery
      /***/
    },

    /* 5 */

    /***/ function (module, exports, __webpack_require__) {
      //remved with gallery
      /***/
    },

    /* 6 */

    /***/ function (module, __webpack_exports__, __webpack_require__) {
      'use strict';

      /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__camelCase__ =
        __webpack_require__(7);

      /**

   * DOM-based Routing

   *

   * Based on {@link http://goo.gl/EUTi53|Markup-based Unobtrusive Comprehensive DOM-ready Execution} by Paul Irish

   *

   * The routing fires all common scripts, followed by the page specific scripts.

   * Add additional events for more control over timing e.g. a finalize event

   */

      var Router = function Router(routes) {
        this.routes = routes;
      };

      if (typeof algolia.client_proxy === 'string') {
        algolia.client_args = {
          requester: {
            send: function (e) {
              e.url = algolia.client_proxy + '?url=' + e.url;

              return new Promise(function (t) {
                var r = new XMLHttpRequest();
                (r.open(e.method, e.url, !0),
                  Object.keys(e.headers).forEach(function (t) {
                    return r.setRequestHeader(t, e.headers[t]);
                  }));
                var n,
                  o = function (e, n) {
                    return setTimeout(function () {
                      (r.abort(),
                        t({
                          status: 0,
                          content: n,
                          isTimedOut: !0,
                        }));
                    }, 1e3 * e);
                  },
                  a = o(e.connectTimeout, 'Connection timeout');
                ((r.onreadystatechange = function () {
                  r.readyState > r.OPENED &&
                    void 0 === n &&
                    (clearTimeout(a),
                    (n = o(e.responseTimeout, 'Socket timeout')));
                }),
                  (r.onerror = function () {
                    0 === r.status &&
                      (clearTimeout(a),
                      clearTimeout(n),
                      t({
                        content: r.responseText || 'Network request failed',
                        status: r.status,
                        isTimedOut: !1,
                      }));
                  }),
                  (r.onload = function () {
                    (clearTimeout(a),
                      clearTimeout(n),
                      t({
                        content: r.responseText,
                        status: r.status,
                        isTimedOut: !1,
                      }));
                  }),
                  r.send(e.data));
              });
            },
          },
        };
      }
      /**

   * Fire Router events

   * @param {string} route DOM-based route derived from body classes (`<body class="...">`)

   * @param {string} [event] Events on the route. By default, `init` and `finalize` events are called.

   * @param {string} [arg] Any custom argument to be passed to the event.

   */

      Router.prototype.fire = function fire(route, event, arg) {
        if (event === void 0) event = 'init';

        document.dispatchEvent(
          new CustomEvent('routed', {
            bubbles: true,

            detail: {
              route: route,

              fn: event,
            },
          }),
        );

        var fire =
          route !== '' &&
          this.routes[route] &&
          typeof this.routes[route][event] === 'function';

        if (fire) {
          this.routes[route][event](arg);
        }
      };

      /**

   * Automatically load and fire Router events

   *

   * Events are fired in the following order:

   ** common init

   ** page-specific init

   ** page-specific finalize

   ** common finalize

   */

      Router.prototype.loadEvents = function loadEvents() {
        var this$1 = this;

        // Fire common init JS

        this.fire('common');

        // Fire page-specific init JS, and then finalize JS

        document.body.className

          .toLowerCase()

          .replace(/-/g, '_')

          .split(/\s+/)

          .map(__WEBPACK_IMPORTED_MODULE_0__camelCase__['a' /* default */])

          .forEach(function (className) {
            this$1.fire(className);

            this$1.fire(className, 'finalize');
          });

        // Fire common finalize JS

        this.fire('common', 'finalize');
      };

      /* harmony default export */ __webpack_exports__['a'] = Router;

      /***/
    },

    /* 7 */

    /***/ function (module, __webpack_exports__, __webpack_require__) {
      'use strict';

      /**

   * the most terrible camelizer on the internet, guaranteed!

   * @param {string} str String that isn't camel-case, e.g., CAMeL_CaSEiS-harD

   * @return {string} String converted to camel-case, e.g., camelCaseIsHard

   */

      /* harmony default export */ __webpack_exports__['a'] = function (str) {
        return (
          '' +
          str.charAt(0).toLowerCase() +
          str
            .replace(/[\W_]/g, '|')
            .split('|')

            .map(function (part) {
              return '' + part.charAt(0).toUpperCase() + part.slice(1);
            })

            .join('')

            .slice(1)
        );
      };

      /***/
    },

    /* 8 */

    /***/ function (module, __webpack_exports__, __webpack_require__) {
      'use strict';

      /* WEBPACK VAR INJECTION */ (function ($) {
        /* harmony default export */ __webpack_exports__['a'] = {
          init: function init() {
            // JavaScript to be fired on all pages

            console.log('vardaga-2021 common.js LOADED');

            /* SEARCH */

            var $search = $('header.banner .search-form');

            $search.submit(function (e) {
              if ($(window).width() >= 992) {
                return true;
              }

              /**

   * Event processed twice

   * here and in common.js

   */

              //        e.preventDefault();

              //        $search.toggleClass('open');

              //        var $input = $search.find('.search-field');

              //        $input.focus();
            });
          },

          finalize: function finalize() {
            // JavaScript to be fired on all pages, after page specific JS is fired
          },
        };

        /* WEBPACK VAR INJECTION */
      }).call(__webpack_exports__, __webpack_require__(0));

      /***/
    },

    /* 9 */

    /***/ function (module, __webpack_exports__, __webpack_require__) {
      'use strict';

      /* harmony default export */ __webpack_exports__['a'] = {
        init: function init() {
          // JavaScript to be fired on the home page

          console.log('vardaga-2021 home.js LOADED');
        },

        finalize: function finalize() {
          // JavaScript to be fired on the home page, after the init JS
        },
      };

      /***/
    },

    /* 10 */

    /***/ function (module, __webpack_exports__, __webpack_require__) {
      //remved with gallery
      /***/
    },

    /* 11 */

    /***/ function (module, __webpack_exports__, __webpack_require__) {
      'use strict';

      /* WEBPACK VAR INJECTION */ (function ($) {
        /* global algolia, instantsearch, algoliaExtra, algoliasearch */

        /* harmony default export */ __webpack_exports__['a'] = {
          init: function init() {
            // JavaScript to be fired on the home page

            /*

      The main search (the all) is not possible to add the verksamheter mixed in within the list.

      Or at least is not possible with the version of instantsearch.js that we're using.

      https://www.algolia.com/doc/guides/building-search-ui/ui-and-ux-patterns/multi-index-search/js/?client=react

  

      The solution implemented here is a hack, not reliable.

      */

            if ($('#algolia-search-box').length <= 0) {
              return;
            }

            if (typeof algolia === 'undefined') {
              return;
            }

            var labels = algoliaExtra.text;

            jQuery('.ss_load_morebtn').text(labels.viewMore);

            function loadermorebtn() {
              // var list = jQuery("#nav-all .ais-InfiniteHits-item");

              jQuery('#nav-all .ais-InfiniteHits-item').hide();

              let size_li = jQuery('#nav-all .ais-InfiniteHits-item').size();

              if (size_li < 20) {
                jQuery('.ss_load_morebtn').hide();
              } else {
                jQuery('.ss_load_morebtn').show();
              }

              let x = 20;

              jQuery('#nav-all .ais-InfiniteHits-item:lt(' + x + ')').show();

              jQuery('.ss_load_morebtn').click(function () {
                clearInterval(setloadmorebtn);

                x = x + 20 <= size_li ? x + 20 : size_li;

                jQuery('#nav-all .ais-InfiniteHits-item:lt(' + x + ')').show();

                if (size_li <= x) {
                  jQuery('.ss_load_morebtn').hide();
                } else {
                  jQuery('.ss_load_morebtn').show();
                }
              });
            }

            var intervalId = window.setInterval(function () {
              var counters = jQuery('#nav-all').find('li').length;

              jQuery('.ais-Stats-text_ss').text(
                `Din sökning gav ${counters} resultat`,
              );
            }, 100);

            let setloadmorebtn = window.setInterval(function () {
              loadermorebtn();
            }, 100);

            if (
              algolia.indices.searchable_posts === undefined &&
              $('.admin-bar').length > 0
            ) {
              alert(
                'It looks like you haven\'t indexed the searchable posts index. Please head to the Indexing page of the Algolia Search plugin and index it.',
              );
            }

            //STAT NAV LOGIC

            $('.nav-tabbed-search a[data-toggle="tab"]').on(
              'show.bs.tab',
              function (e) {
                //e.target // newly activated tab

                //e.relatedTarget // previous active tab

                var relatedStat = $(e.target).attr('data-stat');

                console.log(relatedStat);

                $('#stats-nav .tab-pane')
                  .removeClass('show')
                  .removeClass('active');

                $(relatedStat).addClass('show').addClass('active');
              },
            );

            //SEARCH INIT

            var main = instantsearch({
              indexName: algolia.indices.searchable_posts.name,

              searchClient: algoliasearch(
                algolia.application_id,
                algolia.search_api_key,
                algolia.client_args,
              ),

              routing: {
                router: instantsearch.routers.history({ writeDelay: 1000 }),

                stateMapping: {
                  stateToRoute: function stateToRoute(indexUiState) {
                    return {
                      s: indexUiState[algolia.indices.searchable_posts.name]
                        .query,

                      page: indexUiState[algolia.indices.searchable_posts.name]
                        .page,
                    };
                  },

                  routeToState: function routeToState(routeState) {
                    var indexUiState = {};

                    indexUiState[algolia.indices.searchable_posts.name] = {
                      query: routeState.s,

                      page: routeState.page,
                    };

                    return indexUiState;
                  },
                },
              },

              searchFunction: function (helper) {
                var query = helper.state.query;

                verksamheterSearch.helper.setQuery(query);

                verksamheterSearch.helper.search();

                unitSearch.helper.setQuery(query);

                unitSearch.helper.search();

                postsSearch.helper.setQuery(query);

                postsSearch.helper.search();

                pagesSearch.helper.setQuery(query);

                pagesSearch.helper.search();

                helper.search();

                setTimeout(function () {
                  let counters = jQuery(
                    '#nav-all .ais-InfiniteHits-item',
                  ).length;

                  jQuery('.ais-Stats-text_ss').text(
                    `Din sökning gav ${counters}resultat`,
                  );

                  loadermorebtn();
                }, 100);
              },
            });

            var verksamheterSearch = instantsearch({
              searchClient: algoliasearch(
                algolia.application_id,
                algolia.search_api_key,
                algolia.client_args,
              ),

              indexName: algolia.indices.swa_add_on.name,
            });

            var unitSearch = instantsearch({
              searchClient: algoliasearch(
                algolia.application_id,
                algolia.search_api_key,
                algolia.client_args,
              ),

              indexName: algolia.indices.swa_add_on.name,
            });

            var postsSearch = instantsearch({
              searchClient: algoliasearch(
                algolia.application_id,
                algolia.search_api_key,
                algolia.client_args,
              ),

              indexName: algolia.indices.posts_post.name,
            });

            var pagesSearch = instantsearch({
              searchClient: algoliasearch(
                algolia.application_id,
                algolia.search_api_key,
                algolia.client_args,
              ),

              indexName: algolia.indices.posts_page.name,
            });

            //TABS

            var searchHits = instantsearch.widgets.infiniteHits({
              container: document.querySelector('#algolia-hits-all'),

              templates: {
                empty: '',

                item: wp.template('instantsearch-hit'), //instantsearch-hit-2

                showMoreText: labels.viewMore,
              },
            });

            var unitHits = instantsearch.widgets.infiniteHits({
              container: document.querySelector('#algolia-hits-unit'),

              templates: {
                empty: '',

                item: wp.template('instantsearch-hit--Verksamheter'), //instantsearch-hit-2

                showMoreText: labels.viewMore,
              },
            });

            var verksamheterHits = instantsearch.widgets.infiniteHits({
              container: document.querySelector('#algolia-hits-verksamheter'),

              templates: {
                empty: labels.noResults,

                item: wp.template('instantsearch-hit--Verksamheter'), //instantsearch-hit-verksamheter2

                showMoreText: labels.viewMore,
              },
            });

            var postsSearchHits = instantsearch.widgets.infiniteHits({
              container: document.querySelector('#algolia-hits-posts'),

              templates: {
                empty: labels.noResults,

                item: wp.template('instantsearch-hit'), //instantsearch-hit-2

                showMoreText: labels.viewMore,
              },
            });

            var pagesSearchHits = instantsearch.widgets.infiniteHits({
              container: document.querySelector('#algolia-hits-pages'),

              templates: {
                empty: labels.noResults,

                item: wp.template('instantsearch-hit'), //instantsearch-hit-2

                showMoreText: labels.viewMore,
              },
            });

            var configUnit = instantsearch.widgets.configure({
              hitsPerPage: 1000,
            });

            var configall = instantsearch.widgets.configure({
              hitsPerPage: 1000,
            });

            var configUnitTab = instantsearch.widgets.configure({
              hitsPerPage: 20,
            });

            main.addWidget(searchHits);

            main.addWidget(configall);

            unitSearch.addWidget(unitHits);

            unitSearch.addWidget(configUnit);

            verksamheterSearch.addWidget(verksamheterHits);

            verksamheterSearch.addWidget(configUnitTab);

            postsSearch.addWidget(postsSearchHits);

            pagesSearch.addWidget(pagesSearchHits);

            //END TABS

            //SEARCH BOX

            var searchBox = instantsearch.widgets.searchBox({
              container: '#algolia-search-box',

              placeholder: labels.search,

              showReset: false,

              showSubmit: false,

              showLoadingIndicator: false,
            });

            main.addWidget(searchBox);

            //STATS WIDGET

            var statsMain = instantsearch.widgets.stats({
              container: '#algolia-stats',

              templates: {
                text:
                  '{{#hasNoResults}}' +
                  labels.zeroResult +
                  '{{/hasNoResults}}{{#hasOneResult}}' +
                  labels.oneResult +
                  '{{/hasOneResult}}\n  {{#hasManyResults}}' +
                  labels.nResult +
                  '{{/hasManyResults}}',
              },
            });

            var statsPages = instantsearch.widgets.stats({
              container: '#algolia-stats-pages',

              templates: {
                text:
                  '{{#hasNoResults}}' +
                  labels.zeroResult +
                  '{{/hasNoResults}}{{#hasOneResult}}' +
                  labels.oneResult +
                  '{{/hasOneResult}}\n  {{#hasManyResults}}' +
                  labels.nResult +
                  '{{/hasManyResults}}',
              },
            });

            var statsVerksamheter = instantsearch.widgets.stats({
              container: '#algolia-stats-verksamheter',

              templates: {
                text:
                  '{{#hasNoResults}}' +
                  labels.zeroResult +
                  '{{/hasNoResults}}{{#hasOneResult}}' +
                  labels.oneResult +
                  '{{/hasOneResult}}\n  {{#hasManyResults}}' +
                  labels.nResult +
                  '{{/hasManyResults}}',
              },
            });

            var statsPosts = instantsearch.widgets.stats({
              container: '#algolia-stats-posts',

              templates: {
                text: '{{#hasNoResults}}Din sökning gav 0 resultat{{/hasNoResults}}{{#hasOneResult}}Din sökning gav 1 resultat{{/hasOneResult}}\n  {{#hasManyResults}}Din sökning gav {{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} resultat{{/hasManyResults}}',
              },
            });

            // main.addWidget(statsMain);

            verksamheterSearch.addWidget(statsVerksamheter);

            postsSearch.addWidget(statsPosts);

            pagesSearch.addWidget(statsPages);

            //BOOTSTRAP

            verksamheterSearch.start();

            unitSearch.start();

            postsSearch.start();

            pagesSearch.start();

            main.start();

            $('#algolia-search-box input').attr('type', 'search').select();
          },

          finalize: function finalize() {
            // JavaScript to be fired on the home page, after the init JS
          },
        };

        /* WEBPACK VAR INJECTION */
      }).call(__webpack_exports__, __webpack_require__(0));

      /***/
    },

    /* 12 */

    /***/ function (module, exports) {
      // removed by extract-text-webpack-plugin
      /***/
    },

    /******/
  ],
);

//# sourceMappingURL=main.js.map
